import React from 'react';
import styled from 'styled-components';
import HeroSection from '../components/HeroSection';
import Skills from '../components/Skills';

const PageStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const HomePage = () => (
  <PageStack>
    <HeroSection />
    <Skills />
  </PageStack>
);

export default HomePage;

